import React from 'react';

export default function BookingConfirmation({ booking, onNewSearch }) {
  // Extract confirmation ID from Sabre response
  const confirmationId =
    booking?.CreateBookingResponse?.confirmationId ||
    booking?.confirmationId ||
    booking?.CreateBookingRS?.ItineraryRef?.ID ||
    'XXXXXX';

  return (
    <div className="confirmation-card">
      <div className="confirmation-icon">&#9989;</div>
      <h2>Booking Confirmed!</h2>
      <p style={{ color: '#6b7280', marginBottom: 16 }}>
        Your reservation has been created successfully via the Sabre Booking Management API.
      </p>

      <div className="pnr-code">{confirmationId}</div>

      <p style={{ fontSize: 13, color: '#9ca3af' }}>
        Save this confirmation code (PNR locator) for your records.
      </p>

      <div className="confirmation-details">
        <div className="detail-row">
          <span className="detail-label">Status</span>
          <span className="detail-value">
            <span className="status-badge connected">Confirmed</span>
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">API Method</span>
          <span className="detail-value">POST /v1/trip/orders/createBooking</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Environment</span>
          <span className="detail-value">
            <span className="status-badge sandbox">Sandbox (cert)</span>
          </span>
        </div>
      </div>

      {/* Show raw response for development */}
      <details style={{ textAlign: 'left', marginTop: 24 }}>
        <summary style={{ cursor: 'pointer', fontSize: 13, color: '#6b7280' }}>
          View raw API response
        </summary>
        <pre
          style={{
            background: '#f3f4f6',
            padding: 16,
            borderRadius: 8,
            fontSize: 12,
            overflow: 'auto',
            maxHeight: 400,
            marginTop: 8,
          }}
        >
          {JSON.stringify(booking, null, 2)}
        </pre>
      </details>

      <div style={{ marginTop: 24, display: 'flex', gap: 12, justifyContent: 'center' }}>
        <button className="btn btn-primary" onClick={onNewSearch}>
          New Search
        </button>
      </div>
    </div>
  );
}
